class RNG {
  constructor(seed = Math.random() * Math.MAX_SAFE_INTEGER) {
    this.state = seed
  }

  random() {
    var t = this.state += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  }

  randGaussian(std = 1) {
    var u = 0, v = 0;
    while(u === 0) u = this.random(); //Converting [0,1) to (0,1)
    while(v === 0) v = this.random();
    return std * Math.sqrt( -2.0 * Math.log( u ) ) * Math.cos( 2.0 * Math.PI * v ); 
  }

  // fisher yates shuffle on array
  shuffle(array) {
    var m = array.length, t, i;

    while (m) {
      // Pick a remaining element…
      i = Math.floor(this.random() * m--)
  
      // And swap it with the current element.
      t = array[m]
      array[m] = array[i]
      array[i] = t
    }
  
    return array
  }
}

export {
  RNG
}